import { GetShopRecommendedCollectionsQuery } from './getShopRecommendedCollections';

type GetShopRecommendedCollectionsQueryWrapper = {
  data: GetShopRecommendedCollectionsQuery;
  extensions: {
    cost: {
      'shop-content-service': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
      'pdp-recommendations-service': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
      'shop-product-catalog': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
      'item-price-service': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    shopContent: {
      productDetailsPage: {
        recommendedShopCollections: [
          {
            id: 'ShopProductDiscoverSkusCollection:eyJhbmNob3Jfc2t1X2lkIjoiMTk4ODk4NyIsInRyZWF0bWVudCI6InNpbWlsYXJfaXRlbXMifQ==',
            title: 'Similar tops curated for you',
            treatment: 'similar_items',
            shopProducts: {
              nodes: [
                {
                  id: '2059-843430',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Olympia Raglan Colorblock Tee',
                  variantBySkuId: {
                    id: '843430',
                    price: {
                      currency: 'USD',
                      value: 3000,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '2674-638069',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Peter Performance Vee',
                  variantBySkuId: {
                    id: '638069',
                    price: {
                      currency: 'USD',
                      value: 2900,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '57450-1824700',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Wes Performance Vee',
                  variantBySkuId: {
                    id: '1824700',
                    price: {
                      currency: 'USD',
                      value: 2900,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '64886-2199347',
                  brand: {
                    name: 'Under Armour',
                  },
                  name: 'SS Tech 2.0 Novelty Tee',
                  variantBySkuId: {
                    id: '2199347',
                    price: {
                      currency: 'USD',
                      value: 2500,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '104444-2212928',
                  brand: {
                    name: 'Prana',
                  },
                  name: 'Cardiff Pocket Short Sleeve Tee',
                  variantBySkuId: {
                    id: '2212928',
                    price: {
                      currency: 'USD',
                      value: 4500,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '49492-1976655',
                  brand: {
                    name: 'New Balance',
                  },
                  name: 'Essentials Embroidered Tee',
                  variantBySkuId: {
                    id: '1976655',
                    price: {
                      currency: 'USD',
                      value: 3000,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '39252-2212156',
                  brand: {
                    name: 'Vuori',
                  },
                  name: 'Strato Tech SS Tee',
                  variantBySkuId: {
                    id: '2212156',
                    price: {
                      currency: 'USD',
                      value: 4400,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '104690-2210433',
                  brand: {
                    name: 'The North Face',
                  },
                  name: 'Simple Logo Tri-Blend Tee',
                  variantBySkuId: {
                    id: '2210433',
                    price: {
                      currency: 'USD',
                      value: 3000,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '2674-1824316',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Peter Performance Vee',
                  variantBySkuId: {
                    id: '1824316',
                    price: {
                      currency: 'USD',
                      value: 2900,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
              ],
            },
          },
          {
            id: 'ShopProductDiscoverSkusCollection:eyJhbmNob3Jfc2t1X2lkIjoiMTk4ODk4NyIsInRyZWF0bWVudCI6ImJlc3RfYnJhbmRzIn0=',
            title: 'More 01.Algo just for you',
            treatment: 'best_brands',
            shopProducts: {
              nodes: [
                {
                  id: '2059-1824387',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Olympia Raglan Colorblock Tee',
                  variantBySkuId: {
                    id: '1824387',
                    price: {
                      currency: 'USD',
                      value: 3000,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '2059-842396',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Olympia Raglan Colorblock Tee',
                  variantBySkuId: {
                    id: '842396',
                    price: {
                      currency: 'USD',
                      value: 3000,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '56316-2477599',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Tech Commuter 7" Short',
                  variantBySkuId: {
                    id: '2477599',
                    price: {
                      currency: 'USD',
                      value: 5900,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '2059-843430',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Olympia Raglan Colorblock Tee',
                  variantBySkuId: {
                    id: '843430',
                    price: {
                      currency: 'USD',
                      value: 3000,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '42048-1909194',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Oscar Performance Jersey Short',
                  variantBySkuId: {
                    id: '1909194',
                    price: {
                      currency: 'USD',
                      value: 3900,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '102671-2411610',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Gym to Swim Printed 6" Short',
                  variantBySkuId: {
                    id: '2411610',
                    price: {
                      currency: 'USD',
                      value: 5800,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '103078-2411703',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'LINED 7" TEXTURED TRAIN SHORT',
                  variantBySkuId: {
                    id: '2411703',
                    price: {
                      currency: 'USD',
                      value: 5800,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '103237-2477505',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'RESORT PERFORMANCE PRINTED SHORT SLEEVE SHIRT',
                  variantBySkuId: {
                    id: '2477505',
                    price: {
                      currency: 'USD',
                      value: 6800,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
                {
                  id: '55-1779510',
                  brand: {
                    name: '01.Algo',
                  },
                  name: 'Kevin Knoven',
                  variantBySkuId: {
                    id: '1779510',
                    price: {
                      currency: 'USD',
                      value: 6400,
                    },
                    image: {
                      baseUrl:
                        'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                      mediaPath: '/v1654214529/b1fzjcnmmhc1aj1name5.jpg',
                    },
                  },
                },
              ],
            },
          },
        ],
      },
    },
  },
  extensions: {
    cost: {
      'shop-content-service': {
        maxQueryCost: 5000,
        requestedQueryCost: 4,
        actualQueryCost: 3,
      },
      'pdp-recommendations-service': {
        maxQueryCost: 5000,
        requestedQueryCost: 7,
        actualQueryCost: 9,
      },
      'shop-product-catalog': {
        maxQueryCost: 15000,
        requestedQueryCost: 723,
        actualQueryCost: 167,
      },
      'item-price-service': {
        maxQueryCost: 5000,
        requestedQueryCost: 4,
        actualQueryCost: 54,
      },
    },
  },
} as GetShopRecommendedCollectionsQueryWrapper;
